/*
 * @Date: 2020-08-26 16:39:31
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-09 16:18:37
 * @FilePath: \pc-mall\src\router.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import buyTicket from './views/trip/tripList.vue'
// import buyTicket from './views/buyTicket.vue'
import tripDetail from './views/trip/tripDetail.vue'
import tripBook from './views/trip/tripBook.vue'
import checkOrder from './views/checkOrder.vue'
import myOrder from './views/myOrder.vue'
import orderDetail from './views/orderDetail.vue'
import fillInOrder from './views/fillInOrder.vue'
import payOrder from './views/payOrder.vue'
import paySucceed from './views/paySucceed.vue'
import payFailed from './views/payFailed.vue'
import fillInOrderFeery from './views/fillInOrderFeery.vue'
import login from './views/login.vue'
import registered from './views/registered.vue'
import HotelList from './views/hotel/hotelList.vue'
import HoteDetails from './views/hotel/hoteDetails.vue'
import HotelBook from './views/hotel/hotelBook.vue'
import PackageTicketList from './views/packageTicket/packageTicketList.vue'
import PackageTicketDetails from './views/packageTicket/packageTicketDetails.vue'
import PackageTicketBook from './views/packageTicket/packageTicketBook.vue'
import FoodList from './views/food/foodList.vue'
import FoodDetail from './views/food/foodDetail.vue'
import FoodBooking from './views/food/foodBooking.vue'
import RetailList from './views/retail/retailList.vue'
import RetailDetail from './views/retail/retailDetails.vue'
import RetailOrderConfirm from './views/retail/retailOrderConfirm.vue'
import Pay from './views/retail/pay.vue'
import Cart from './views/retail/cart.vue'
import PersonalCenter from './views/mine/personalCenter'
import PersonalEdit from './views/mine/personalEdit'
import OrderListNew from './views/orderNew/orderList'
import retailOrderList from './views/orderNew/retailOrderList'
import OrderDetailNew from './views/orderNew/orderDetail'
import OrderEvaluate from './views/orderNew/orderEvaluate'
import PersonalInfo from './views/mine/personalInfo'
import ReceiveAddress from './views/mine/receiveAddress'
import PayOrderNew from './views/payOrderNew'
import PayOrderPackageTicket from './views/payOrderPackageTicket'
import AfterSalesOrderList from './views/afterSales/afterSalesOrderList'
import AfterSalesDetail from './views/afterSales/afterSalesDetail'
import AfterSalesApply from './views/afterSales/afterSalesApply'
import AfterSalesRecord from './views/afterSales/afterSalesRecord'

Vue.use(Router)
const routes1 = new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: home,
    redirect: 'buyTicket',
    children: [
      {
        path: '/',
        name: 'buyTicket',
        component: buyTicket
      },
      {
        path: '/tripDetail',
        name: 'tripDetail',
        component: tripDetail
      },
      {
        path: '/tripBook',
        name: 'tripBook',
        component: tripBook
      },
      {
        path: '/checkOrder',
        name: 'checkOrder',
        component: checkOrder
      }, {
        path: '/myOrder',
        name: 'myOrder',
        component: myOrder
      }, {
        path: '/orderDetail',
        name: 'orderDetail',
        component: orderDetail
      }, {
        path: '/fillInOrder',
        name: 'fillInOrder',
        component: fillInOrder
      }, {
        path: '/fillInOrderFeery',
        name: 'fillInOrderFeery',
        component: fillInOrderFeery
      }, {
        path: '/payOrder',
        name: 'payOrder',
        component: payOrder
      }, {
        path: '/payOrderNew',
        name: 'payOrderNew',
        component: PayOrderNew
      }, {
        path: '/payOrderPackageTicket',
        name: 'payOrderPackageTicket',
        component: PayOrderPackageTicket
      }, {
        path: '/paySucceed',
        name: 'paySucceed',
        component: paySucceed
      }, {
        path: '/payFailed',
        name: 'payFailed',
        component: payFailed
      }, {
        path: '/login',
        name: 'login',
        component: login
      }, {
        path: '/registered',
        name: 'registered',
        component: registered
      }, {
        path: '/hotelList',
        name: 'hotelList',
        component: HotelList
      },
      {
        path: '/hoteDetails',
        name: 'hoteDetails',
        component: HoteDetails
      },
      {
        path: '/hotelBook',
        name: 'hotelBook',
        component: HotelBook
      },
      {
        path: '/packageTicketList',
        name: 'packageTicketList',
        component: PackageTicketList
      },
      {
        path: '/packageTicketDetails',
        name: 'packageTicketDetails',
        component: PackageTicketDetails
      },
      {
        path: '/packageTicketBook',
        name: 'packageTicketBook',
        component: PackageTicketBook
      },
      {
        path: '/foodList',
        name: 'foodList',
        component: FoodList
      }, {
        path: '/foodDetail',
        name: 'foodDetail',
        component: FoodDetail
      }, {
        path: '/foodBooking',
        name: 'foodBooking',
        component: FoodBooking
      }, {
        path: '/retailList',
        name: 'retailList',
        component: RetailList
      }, {
        path: '/retailDetail',
        name: 'retailDetail',
        component: RetailDetail
      }, {
        path: '/retailOrderConfirm',
        name: 'retailOrderConfirm',
        component: RetailOrderConfirm
      }, {
        path: '/cart',
        name: 'cart',
        component: Cart
      }, {
        path: '/pay',
        name: 'pay',
        component: Pay
      }, {
        path: '/personalCenter',
        name: 'personalCenter',
        component: PersonalCenter,
        redirect: '/orderListNew',
        children: [
          {
            path: '/orderListNew',
            name: 'orderListNew',
            component: OrderListNew,
            children: [
              {
                path: '/tripOrderList',
                name: 'tripOrderList',
                component: myOrder
              },
              {
                path: '/retailOrderList',
                name: 'retailOrderList',
                component: retailOrderList
              }
            ]
          }, {
            path: '/orderDetailNew',
            name: 'orderDetailNew',
            component: OrderDetailNew
          }, {
            path: '/orderEvaluate',
            name: 'orderEvaluate',
            component: OrderEvaluate
          }, {
            path: '/personalInfo',
            name: 'personalInfo',
            component: PersonalInfo
          }, {
            path: '/receiveAddress',
            name: 'receiveAddress',
            component: ReceiveAddress
          }, {
            path: '/afterSalesOrderList',
            name: 'afterSalesOrderList',
            component: AfterSalesOrderList
          }, {
            path: '/afterSalesDetail',
            name: 'afterSalesDetail',
            component: AfterSalesDetail
          }, {
            path: '/afterSalesApply',
            name: 'afterSalesApply',
            component: AfterSalesApply
          }, {
            path: '/afterSalesRecord',
            name: 'afterSalesRecord',
            component: AfterSalesRecord
          }
        ]
      }, {
        path: '/personalEdit',
        name: 'personalEdit',
        component: PersonalEdit
      }
    ]
  }
  ]
})
// 路由跳转
var _hmt = []
window._hmt = _hmt // 必须把_hmt挂载到window下，否则找不到
routes1.beforeEach((to, from, next) => {
  // 统计代码
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next()
})
export default routes1
